var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "z-table", class: _vm.tableClass }, [
    _c("div", { staticClass: "z-table__container" }, [
      _c("table", [
        _c("thead", [
          _c(
            "tr",
            { staticClass: "z-table-row z-table-row--head" },
            _vm._l(_vm.columns, function (item, index) {
              return _c(
                "th",
                {
                  key: index,
                  staticClass: "z-table-col z-table-col--head",
                  class: _vm.columnClass(index),
                  on: {
                    click: function ($event) {
                      return _vm.sort(index)
                    },
                  },
                },
                [_c("span", { domProps: { innerHTML: _vm._s(item) } })]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm.hasDefaultSlotData
              ? [_vm._t("default")]
              : _vm._l(_vm.tableData, function (row, rowIndex) {
                  return _c(
                    "z-table-row",
                    { key: rowIndex },
                    _vm._l(row, function (col, columnIndex) {
                      return _c(
                        "z-table-col",
                        { key: columnIndex, attrs: { index: columnIndex } },
                        [_c("span", { domProps: { innerHTML: _vm._s(col) } })]
                      )
                    }),
                    1
                  )
                }),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.hasAddSlotData
      ? _c("div", { staticClass: "z-table__footer" }, [_vm._t("add")], 2)
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }